<template>
	<div class="container">
		<mt-popup
            v-model="isShowtranslateInfo"
            position="bottom"
            v-bind:close-on-click-modal="false"
		>
        <div class="translate-wrapper">
            <div class="translate-header"><span class="title">保障</span><span class="iconfont close" v-on:click="closeTranslateInfo(false)">&#xe65a;</span></div>
            <div class="translate-item">
                <div class="item" v-if="storeInfo.store_shiti"><div class="dt">实体认证</div><div class="dd">平台核实该店铺有线下实体店</div></div>
                <div class="item" v-if="storeInfo.store_qtian"><div class="dt">实物拍摄</div><div class="dd">商品图片均由线下实体店拍摄</div></div>
                <div class="item" v-if="storeInfo.store_zhping"><div class="dt">正品保障</div><div class="dd">正品保障，假一赔四</div></div>
                <div class="item" v-if="storeInfo.store_erxiaoshi"><div class="dt">急速发货</div><div class="dd">24小时内急速发货</div></div>
                <div class="item" v-if="storeInfo.store_tuihuo"><div class="dt">退货承诺</div><div class="dd">满足相应条件时，享受急速退货</div></div>
                <div class="item" v-if="storeInfo.store_shiyong"><div class="dt">试用中心</div><div class="dd">店铺接受买家试用，买家可与店铺对话沟通</div></div>
                <div class="item" v-if="storeInfo.store_xiaoxie"><div class="dt">消费者保障</div><div class="dd">买家享有消费者权益保护</div></div>
                <div class="item" v-if="storeInfo.store_huodaofk"><div class="dt">货到付款</div><div class="dd">买家享有先购物，货到在付款</div></div>
                <div class="item" v-if="storeInfo.store_avaliable_deposit > 0"><div class="dt">保证金</div><div class="dd">店铺已缴纳保证金：{{storeInfo.store_avaliable_deposit}}</div></div>
            </div>
        </div>
		</mt-popup>
		
		
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import flexLine from '../../../flexLine'
export default {
  components:{
    flexLine
  },
  data () {
    return {
      
    }
  },

  props: {
    isShowtranslateInfo: {
      type: Boolean,
      default: false
    }
  },

  created () {
	  
  },

  computed: {
    ...mapState({
      storeInfo: state => state.goodsdetail.storeInfo,
      chooseinfo: state => state.goodsdetail.chooseinfo
    }),
  },


  mounted () {
  },

  methods: {
    ...mapActions({
      getGoodsDetail: 'getGoodsDetail'
    }),
    ...mapMutations({
      saveTranslateState: 'saveTranslateState'
    }),

    // 关闭购物车浮层
    closeTranslateInfo (value) {
      this.saveTranslateState(value)
    },

    
  }
}
</script>

<style lang="scss" scoped>
	.mint-popup-bottom {
		overflow: initial;
		height: 80%;
        border-radius: 0.25rem 0.25rem 0 0;
	}
    .translate-wrapper{
        background: rgba(255, 255, 255, 1);
        height: 100%;
        position: absolute;
        width: -webkit-fill-available;
        /* bottom: 0; */
        z-index: 10;
        width: 100%;
        border-radius: 0.25rem 0.25rem 0 0;
        padding: 1rem $pageSpace 0;
        box-sizing: border-box;
        .translate-header{
            display: flex;
            align-items: center;
            .title{
                font-size: .8rem;
            }
            .close{
                margin-left: auto;
            }
        }
        .translate-item{
            background-color: #f5f5f5;
            border-radius: .4rem;
            padding: $pageSpace;
            margin-top: .5rem;
            .item{
                margin: .6rem 0;
                font-size: .7rem;
                .dt{
                    font-size: .7rem;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: .3rem;
                }
                .dd{
                    font-size: .6rem;
                    color: #999;
                }
            }
        }
    }
    

</style>
